<template>
  <div>
    <el-dialog title="查看图片" :visible.sync="imgDetailsShow" width="90%">
      <div class="show-img-wrap">
        <img
          style="max-width: 500px; margin-right: 10px"
          :src="item"
          :key="index"
          v-for="(item, index) in detailsImgs"
        />
      </div>
    </el-dialog>
    <el-dialog
      @close="handleDialogCancel"
      title="上传图片"
      :visible.sync="visible"
    >
      <!-- <div :key="key" v-for="(item, key) in allTags" class="t-i-w"> -->
      <TagItem
        :tagTitleList="oneTags"
        title="分类"
        @clickTagTitleItem="(e) => clickTagTitleItem(e, 1)"
      />
      <TagItem
        :tagTitleList="twoTags"
        title="一级分类"
        @clickTagTitleItem="(e) => clickTagTitleItem(e, 2)"
      />
      <TagItem
        :tagTitleList="threeTags"
        title="二级分类"
        @clickTagTitleItem="(e) => clickTagTitleItem(e, 3)"
      />
      <!-- </div> -->
      <div style="margin-top: 10px">
        <div class="my-upload-wrap">
          <span class="upload-text">{{ uploadText }}</span>
          <input
            ref="uploadInput"
            class="upload-input"
            type="file"
            name="folder"
            multiple
            @change="changFolder"
          />
        </div>
        <div v-if="isProgress" class="upload-tip">
          上传中....<span class="progress">{{ progressNumber }}%</span>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogCancel">取 消</el-button>
        <el-button type="primary" @click="startUpload" :loading="isProgress"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <div class="breadcrumb-wrap">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-custom"
      >
        <el-breadcrumb-item>图片列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="padding: 5px 0px">
      <el-button size="small" type="primary" @click="showDialog"
        >上传图片</el-button
      >
      <el-button
        style="float: right; margin-right: 20px"
        size="small"
        type="danger"
        @click="deleteImg(selectImgs.map((item) => item.id))"
        >批量删除</el-button
      >
      <!-- <el-button
        style="float: right; margin-right: 20px"
        size="small"
        type="primary"
        @click="clickToAddTags"
        >批量打标签</el-button -->
      <!-- > -->
    </div>
    <div></div>

    <div>
      <div class="s-wrap">
        <el-select
          v-model="v1"
          placeholder="请选择"
          @change="(e) => selectChange(e, 1)"
        >
          <el-option
            v-for="item in s_tags"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="v2"
          placeholder="请选择"
          @change="(e) => selectChange(e, 2)"
        >
          <el-option
            v-for="item in s_tags2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="v3"
          placeholder="请选择"
          @change="(e) => selectChange(e, 3)"
        >
          <el-option
            v-for="item in s_tags3"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button style="margin-left:10px" @click="search" type="primary">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>

    <LoadingNoDialog :loading="loading">
      <el-table
        @selection-change="handleSelectionChange"
        class="clear-fix"
        border
        :empty-text="emptyText"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="url" label="图片">
          <template slot-scope="scope">
            <img :src="scope.row.url" style="height: 100px" />
            <img
              :key="key"
              v-for="(item, key) in scope.row.otherUrls"
              :src="item.img"
              style="height: 100px"
            />
          </template>
        </el-table-column>
        <el-table-column min-width="80" prop="mytags" label="标签">
          <template slot-scope="scope">
            <span :key="key" v-for="(item, key) in scope.row.tags">
              <el-tag
                style="margin: 2px 5px"
                type="primary'"
                disable-transitions
                >{{ item.name }}</el-tag
              >
            </span>
          </template>
        </el-table-column>

        <el-table-column label="名称" prop="name"> </el-table-column>

        <el-table-column prop="createdAt" label="创建时间"> </el-table-column>

        <el-table-column label="操作" width="185">
          <template slot-scope="scope">
            <el-button
              @click="deleteImg([scope.row.id])"
              type="danger"
              size="small"
              >删除</el-button
            >
            <el-button
              style="margin-left: 10px"
              @click="showImgDetails(scope.row)"
              type="primary"
              size="small"
              >查看图片</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 10px; text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </LoadingNoDialog>
  </div>
</template>

<script>
import OssUpload from "../../common/OssUpload";
import UploadFileUtils from "./UploadFileUtils";
import axios from "axios";
import moment from "moment";
import LoadingNoDialog from "../../components/LoadingNoDialog.vue";
import Tag from "./Tag.vue";
import TagItem from "./component/TagItem.vue";

import Img from "../../components/Img.vue";

export default {
  name: "Role",
  data() {
    return {
      imgDetailsShow: false, //查看详情
      visible: false,
      emptyText: "暂无数据",
      size: 10,
      page: 1,
      tableData: [],
      total: 0,
      loading: false,
      selectTagIds: [],
      files: [],
      uploadText: "上传图片",
      totalProgress: 0,
      progressIng: 0,
      progressNumber: 0,
      isProgress: false,
      selectImgs: [],
      detailsImgs: [], //显示的图片
      setTagVisible: false,
      allTags: [],
      oneTags: [],
      twoTags: [],
      threeTags: [],
      v1: "",
      v2: "",
      v3: "",
      s_tags: [],
      s_tags2: [],
      s_tags3: [],
      queryTags: [],
      searchTagIds: [],
    };
  },
  components: {
    LoadingNoDialog,
    Tag,
    Img,
    TagItem,
  },
  mounted() {
    this.getAllTags();
    this.getList();
    //this.sortByName();
  },
  methods: {
    reset() {
      this.searchTagIds = [];
      this.v1 = "";
      this.v2 = "";
      this.v3 = "";
      this.page = 1;

      this.getList();
    },
    search() {
      this.searchTagIds = [];
      if (this.v1) {
        this.searchTagIds = [...this.searchTagIds, parseInt(this.v1)];
      }
      if (this.v2) {
        this.searchTagIds = [...this.searchTagIds, parseInt(this.v2)];
      }
      if (this.v3) {
        this.searchTagIds = [...this.searchTagIds, parseInt(this.v3)];
      }
      this.page = 1;

      this.getList();
    },
    selectChange(value, type) {
      console.info(value);
      switch (type) {
        case 1:
          this.v2 = "";
          this.v3 = "";
          let currentOnetag = this.s_tags.find(
            (item) => item.id == parseInt(value)
          );
          this.s_tags2 = currentOnetag.twoTags.map((item) =>
            Object.assign(item, { value: item.id, label: item.name })
          );
          break;

        case 2:
          this.v3 = "";
          let currentTwotag = this.s_tags2.find(
            (item) => item.id == parseInt(value)
          );
          this.s_tags3 = currentTwotag.threeTags.map((item) =>
            Object.assign(item, { value: item.id, label: item.name })
          );

          break;
      }
    },
    clickTagTitleItem(each, type) {
      switch (type) {
        case 1:
          this.threeTags = this.threeTags.map((item) =>
            Object.assign(item, { isActive: false })
          );
          this.twoTags = each.twoTags.map((item, index) =>
            index == 0
              ? Object.assign(item, { isActive: true })
              : Object.assign(item, { isActive: false })
          );
          if (this.twoTags.length > 0) {
            let threeEach = this.twoTags[0];
            this.threeTags = threeEach.threeTags;
          }
          break;
        case 2:
          this.threeTags = this.threeTags.map((item) =>
            Object.assign(item, { isActive: false })
          );

          this.threeTags = each.threeTags.map((item, index) =>
            index == 0
              ? Object.assign(item, { isActive: true })
              : Object.assign(item, { isActive: false })
          );
          break;
        case 3:
          break;
      }
    },

    async getAllTags() {
      let r = await axios.get("/admin/belong");
      if (r.code == 0) {
        this.queryTags = JSON.parse(JSON.stringify(r.data));
        this.s_tags = this.queryTags.map((item) =>
          Object.assign(item, { value: item.id + "", label: item.name })
        );
        this.oneTags = r.data.map((item, index) =>
          index == 0
            ? Object.assign(item, { isActive: true })
            : Object.assign(item, { isActive: false })
        );
        if (r.data.length > 0) {
          this.twoTags = r.data[0].twoTags.map((item, index) =>
            index == 0
              ? Object.assign(item, { isActive: true })
              : Object.assign(item, { isActive: false })
          );
          if (this.twoTags.length > 0) {
            this.threeTags = this.twoTags[0].threeTags;
          }
        }
      }
    },
    sortByName(arra) {
      let res = arra.sort((item1, item2) => {
        let item1Arras = item1.name.split("_");
        let i1 = -1;
        if (item1Arras.length > 1) {
          try {
            i1 = parseInt(item1Arras[0]);
          } catch (e) {}
        }
        let item2Arras = item2.name.split("_");

        let i2 = -1;
        if (item2Arras.length > 1) {
          try {
            i2 = parseInt(item2Arras[0]);
          } catch (e) {}
        }

        return i1 <= i2 ? 1 : -1;
      });
      console.info(res);

      return res;
      // console => arr = ['美国', '日本', '中国']
    },
    handleSelectionChange(val) {
      this.selectImgs = val;
    },
    async deleteImg(imgIds) {
      this.$confirm("是否确认删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: "删除中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let r = await axios.delete("/admin/img/deletes", {
          data: { imgIds: imgIds },
        });
        loading.close();
        if (r.code == 0) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList();
        } else {
          this.$message({
            type: "fail",
            message: "删除失败!",
          });
        }
      });
    },
    handleDialogCancel() {
      this.$refs.uploadInput.value = "";
      this.files = [];
      this.oneTags = this.oneTags.map((item) =>
        Object.assign(item, { isActive: false })
      );
      this.twoTags = this.twoTags.map((item) =>
        Object.assign(item, { isActive: false })
      );
      this.threeTags = this.threeTags.map((item) =>
        Object.assign(item, { isActive: false })
      );
      if (this.isProgress) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
    showDialog() {
      this.uploadText = "上传图片";
      this.allTags = this.allTags.map((item) =>
        Object.assign(item, {
          tags: item.tags.map((e) => Object.assign(e, { isActive: false })),
        })
      );
      this.visible = true;
      this.$nextTick(() => {
        // this.$refs.tag.clearnTag();
      });
    },
    async uploadSuccess(response, row) {
      let url = response.data.url;
      let r = await axios.post("/admin/user/update", {
        payCode: url,
        userId: row.id,
      });
      const that = this;
      that.getList();
    },
    async handleClick(row) {},

    //选中标签
    handleTagClick(tagIds) {
      this.selectTagIds = tagIds;
    },
    //changFolder
    changFolder(e) {
      e.target.valule = "";
      let files = e.target.files;
      this.totalProgress = files.length;
      this.uploadText = `已选${files.length}张图片`;
      this.files = files;
    },
    //上传文件夹
    async startUpload() {
      let files = this.files;
      let uploadFileUtils = new UploadFileUtils();

      let selectTagIds = [
        ...this.oneTags.filter((item) => item.isActive).map((item) => item.id),
        ...this.twoTags.filter((item) => item.isActive).map((item) => item.id),
        ...this.threeTags
          .filter((item) => item.isActive)
          .map((item) => item.id),
      ];

      if (selectTagIds.length == 0) {
        this.$message.warning("请选择标签");
        return;
      }
      if (files.length == 0) {
        this.$message.warning("请选择图片");
        return;
      }
      this.isProgress = true;
this.progressIng=0
      let results = [];
      for (let file of files) {
        let suffix = uploadFileUtils.getSuffix(file.name);
        let r = await this.uploadImg(file, suffix, file.name);
        // otherResults.push({ key: r.objectKey, name: file.name });

        this.progressIng = this.progressIng + 1;
        this.progressNumber = this.progressIng / this.totalProgress;
        //Math.floor()this.progressNumber*100
        this.progressNumber = Math.round(this.progressNumber * 100 * 100) / 100;

        //todo 上传到后台保存
        results.push({ objectKey: r.objectKey, name: file.name });
      }

      let r = await axios.post("/admin/add-img-tags", {
        imgs: results,
        tagIds: selectTagIds,
      });

      if (r.code == 0) {
        this.visible = false;
        this.$message.success("上传成功");
        this.isProgress = false;
        this.getList();
      } else {
        this.$message.warning("不完全上传成功");
      }
    },
    async uploadImg(file, suffix, fileName) {
      let ossUpload = new OssUpload();
      let ossResult = await ossUpload.uploadFileForFileStream(
        file,
        1,
        suffix,
        fileName
      );
      return ossResult;
    },
    async getList() {
      this.loading = true;
      let r = await axios.post("/admin/img/list/v2", {
        page: this.page,
        size: this.size,
        tagIds: this.searchTagIds,
      });
      if (r.code == 51) {
        this.loading = false;
        this.emptyText = "无权限";
        return;
      }
      this.tableData = r.data.rows.map((item) =>
        Object.assign(item, {
          createdAt: moment(item.createdAt).format("YYYY/MM/DD HH:mm:ss"),
        })
      );
      this.tableData = this.tableData.map((item) =>
        Object.assign(item, {
          payCode: item.payCode + `?t=${Date.parse(new Date())}`,
          wallet: item.totalSum - item.remainSum,
        })
      );
      this.total = r.data.count;
      this.loading = false;
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    showImgDetails(item) {
      this.imgDetailsShow = true;
      this.detailsImgs = [];
      this.detailsImgs.push(item.url);
      if (item.otherUrls.length > 0) {
        this.detailsImgs = [
          ...this.detailsImgs,
          ...item.otherUrls.map((item) => item.url),
        ];
      }
    },

    async sureTagImg() {
      if (this.selectTagIds.length == 0) {
        this.$message.warning("请选择标签");
        return;
      }

      function getParentTags(tags, selectTags) {
        let parentTags = [];
        for (let oTag of tags) {
          for (let tTag of oTag.tags) {
            for (let threeTag of tTag.tags) {
              let isIncludeTag = selectTags.includes(threeTag.id);
              if (isIncludeTag) {
                parentTags.push(oTag.id);
                parentTags.push(tTag.id);
              }
            }
          }
        }
        parentTags = Array.from(new Set(parentTags));
        return parentTags;
      }
      let rtags = getParentTags(this.$store.state.tags, this.selectTagIds);
      let r = await axios.post("/admin/tag/add/img", {
        tagIds: [...this.selectTagIds, ...rtags],
        imgIds: this.selectImgs.map((item) => item.id),
      });
      this.setTagVisible = false;
      this.selectTagIds = [];
      this.tagIds = [];
      this.getList();
    },
  },
};
</script>
<style scope>
.my-upload-wrap {
  display: inline-block;
  border-radius: 3px;
  background: #409eff;
  position: relative;
  height: 30px;
  width: 100px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}

.upload-input {
  opacity: 0;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 80px;
  height: 30px;
  cursor: pointer;
}

.upload-text {
  cursor: pointer;
  color: white;
}
.upload-tip {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  margin-left: 20px;
}
.progress {
  font-size: 12px;
  color: red;
  margin-left: 10px;
}
.show-img-wrap {
  display: flex;
  justify-content: center;
}
.t-i-w {
  padding: 5px 0px;
}
.s-wrap {
  padding: 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/main/admin/ImgList2.vue